import { render, staticRenderFns } from "./SuppliersFilters.vue?vue&type=template&id=2479a276&scoped=true&"
import script from "./SuppliersFilters.vue?vue&type=script&lang=js&"
export * from "./SuppliersFilters.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersFilters.vue?vue&type=style&index=0&id=2479a276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2479a276",
  null
  
)

export default component.exports